/**
 * Especialidade médica predominante da clínica — usada para padrões e fluxos específicos.
 * Manter alinhado com Backend/backend/src/constants/clinicMedicalSpecialties.ts
 */
export const CLINIC_MEDICAL_SPECIALTY_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '', label: 'Não definido / múltiplas especialidades' },
  { value: 'medicina_geral', label: 'Medicina geral / Clínica médica' },
  { value: 'medicina_familiar', label: 'Medicina de família e comunidade' },
  { value: 'medicina_esportiva', label: 'Medicina esportiva' },
  { value: 'medicina_do_trabalho', label: 'Medicina do trabalho' },
  { value: 'geriatria', label: 'Geriatria' },
  { value: 'pediatria', label: 'Pediatria' },
  { value: 'cardiologia', label: 'Cardiologia' },
  { value: 'dermatologia', label: 'Dermatologia' },
  { value: 'endocrinologia', label: 'Endocrinologia' },
  { value: 'gastroenterologia', label: 'Gastroenterologia' },
  { value: 'ginecologia_obstetricia', label: 'Ginecologia e Obstetrícia' },
  { value: 'neurologia', label: 'Neurologia' },
  { value: 'ortopedia', label: 'Ortopedia / Traumatologia' },
  { value: 'otorrinolaringologia', label: 'Otorrinolaringologia' },
  { value: 'oftalmologia', label: 'Oftalmologia' },
  { value: 'urologia', label: 'Urologia' },
  { value: 'psiquiatria', label: 'Psiquiatria' },
  { value: 'psicologia', label: 'Psicologia (clínica)' },
  { value: 'pneumologia', label: 'Pneumologia' },
  { value: 'reumatologia', label: 'Reumatologia' },
  { value: 'nefrologia', label: 'Nefrologia' },
  { value: 'oncologia', label: 'Oncologia' },
  { value: 'infectologia', label: 'Infectologia' },
  { value: 'hematologia', label: 'Hematologia' },
  { value: 'alergologia_imunologia', label: 'Alergia e imunologia' },
  { value: 'nutrologia', label: 'Nutrologia' },
  { value: 'anestesiologia', label: 'Anestesiologia' },
  { value: 'cirurgia_geral', label: 'Cirurgia geral' },
  { value: 'cirurgia_plastica', label: 'Cirurgia plástica' },
  { value: 'medicina_estetica', label: 'Medicina estética / Harmonização' },
  { value: 'odontologia', label: 'Odontologia' },
  { value: 'fisioterapia', label: 'Fisioterapia / Reabilitação' },
];
